import { render } from "./ServiceStatusTable.vue?vue&type=template&id=4fa7448a&ts=true"
import script from "./ServiceStatusTable.vue?vue&type=script&lang=ts"
export * from "./ServiceStatusTable.vue?vue&type=script&lang=ts"

import "./ServiceStatusTable.vue?vue&type=style&index=0&id=4fa7448a&lang=scss"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__